import {myDevice} from "./device";

function rowSlide(className, slideNumSP, slideNum, prevBtn, nextBtn) {
  let options = {};
  const slider = document.querySelector(className);
  const sliderSlides = slider.querySelectorAll('.swiper-slide');
  let swiper = null;

  function initializeSwiper() {
    if (myDevice) {
      if (sliderSlides.length > 2) {
        options = {
          loop: true,
          slidesPerView: slideNumSP,
          spaceBetween: 10,
          speed: 1000,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
          },
					breakpoints: {
						768: {
							spaceBetween: 20,
							slidesPerView: slideNum,
						}
					}
        };
      } else {
        options = {
          loop: false,
          autoplay: false,
          slidesPerView: slideNumSP,
          spaceBetween: 10,

					breakpoints: {
						768: {
							spaceBetween: 20,
							slidesPerView: slideNum,
						}
					}
        };

        document.querySelector(prevBtn).style.display = 'none';
        document.querySelector(nextBtn).style.display = 'none';
      }
    } else {
			if (sliderSlides.length > 4) {
        options = {
          loop: true,
          spaceBetween: 20,
          slidesPerView: slideNum,
          speed: 1000,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
          },
					breakpoints: {
						768: {
							spaceBetween: 20,
							slidesPerView: slideNum,
						}
					}
        };
      } else {
        options = {
          loop: false,
          autoplay: false,
          slidesPerView: slideNum,
          spaceBetween: 20,
					breakpoints: {
						768: {
							spaceBetween: 20,
							slidesPerView: slideNum,
						}
					}
        };

        document.querySelector(prevBtn).style.display = 'none';
        document.querySelector(nextBtn).style.display = 'none';
      }
    }

    if (swiper !== null) {
      swiper.destroy();
    }

    swiper = new Swiper(slider, options);
  }

  initializeSwiper();

  window.addEventListener('resize', initializeSwiper);
}


export {rowSlide}
